import React, { useEffect, useState } from "react";
import { User } from "~/common/Store/models/User";
import ValidationError from "../Pricing/AddToCart/ValidationError";
import OrderGuide from "../Pricing/OrderGuide";
import { PricingProduct } from "~/ProductDetails/Pricing/PricingProduct";
import WishListButton from "./WishListButton";
import isItemAlreadyInOrderGuide from "../Pricing/OrderGuide/isItemAlreadyInOrderGuide";
interface Props {
  user: User;
  handleVgSelectionError: (validationError: ValidationError) => void;
  product: PricingProduct;
  addToCartQuantity: string;
}
const UserLists = ({
  user,
  handleVgSelectionError,
  product,
  addToCartQuantity
}: Props) => {
  const [itemAlreadyInOrderGuide, setItemAlreadyInOrderGuide] = useState(false);
  const {
    itemNumber
  } = product;
  useEffect(() => {
    if (user.orderGuides) {
      isItemAlreadyInOrderGuide(itemNumber).then(isInOrderGuide => {
        setItemAlreadyInOrderGuide(isInOrderGuide);
      });
    }
  }, [itemNumber, setItemAlreadyInOrderGuide, user.orderGuides]);
  return <div className={`bg-white border border-solid border-gray-200 mb-0 border-b-0 border-r-0 xs:border-r border-l-0 xs:border-l  xs:border-b xs:mb-5 md:bg-transparent md:border-none md:py-0 md:mb-0 ${product.showRewardsCardAd ? "border-t-0 pb-5 xs:pb-4 pt-3" : "py-5 xs:py-4 "}`} data-sentry-component="UserLists" data-sentry-source-file="index.tsx">
      <div className="flex justify-center w-full">
        <WishListButton user={user} handleVgSelectionError={handleVgSelectionError} product={product} addToCartQuantity={addToCartQuantity} data-sentry-element="WishListButton" data-sentry-source-file="index.tsx" />
        <OrderGuide user={user} quantity={addToCartQuantity || "1"} product={product} handleVgSelectionError={handleVgSelectionError} data-sentry-element="OrderGuide" data-sentry-source-file="index.tsx" />
      </div>
      <div>
        {itemAlreadyInOrderGuide && <label className="sub-text text-center pt-2 mb-0">
            {"This item is in your Order Guide. - "}
            <a className="underline" href="/myproducts.html?ignore_timeout=true">
              View Order Guide
            </a>
          </label>}
      </div>
    </div>;
};
export default UserLists;